import React, { ReactNode } from "react";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import ClipLoader from "react-spinners/ClipLoader";
import ApiFailed from '../../Utils/ApiFailed';
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import { APIGetLoggerConnectionsModel, buildAPIGetLoggerConnectionsModel } from "models/APIGetLoggerConnectionsModel";
// DevExtreme
import { DataGrid, Column, Export, Scrolling, FilterRow, StateStoring, Pager, Paging, HeaderFilter, Label } from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

import IconButton from '@mui/material/IconButton';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';


//Moment date/time formatting
//https://momentjs.com/docs/
import moment from 'moment';
import { adjustTime } from '../../Utils/AdjustTime'

import { withStyles, createStyles } from '@mui/styles';
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import PollOutlinedIcon from '@mui/icons-material/PollOutlined';

//DevExtreme
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import Chart, { CommonSeriesSettings, ArgumentAxis, Series, Legend, Aggregation, ValueAxis, ZoomAndPan, ScrollBar, Point } from 'devextreme-react/chart';
import DateBox from 'devextreme-react/date-box';
import { injectIntl, IntlShape } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import Loader from '../../Utils/Loader/NewLoader2025'
import { APIGetLoggerReportsModel, buildAPIGetLoggerReportsModel } from '../../models/APIGetLoggerReportsModel';

const styles: Record<string, any> = {
    formControl: {
        minWidth: 120,
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        color: "#FFFFFF",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

const style = createStyles(styles);

interface Props {
    classes: {
        cardTitleWhite: string;
    };
    serials?: string[];
    site?: number;
    intl: IntlShape
    model: string
}

interface State {
    loading: boolean;
    tableHidden: boolean;
    authorized: boolean;
    maxValue: number;
    minValue: number;
    channels: string[];
    channelFilters: boolean[];
    filterValue: Array<string | string[]>;
    startDate: Date;
    endDate: Date;
    connectionsData: Array<APIGetLoggerConnectionsModel>;
    temperatureData: Array<TemperatureData>
    graphData: Array<
        {
            date: Date;
            signal: number | null;
            battery: number | null;
            temperature: number | null;
        }
    > | undefined;
}

interface TemperatureData {
    date: Date
    temperature: number
}

class ConnectionsPanel extends React.Component<Props, State> {

    gridRef: React.RefObject<DataGrid>;

    constructor(props: Readonly<Props>) {
        super(props);
        this.gridRef = React.createRef();

        locale(sessionStorage.getItem('language'));
        loadMessages(frMessages);
        loadMessages(deMessages);
        loadMessages(esMessages);
        loadMessages(ptMessages);


        this.state = {
            loading: true,
            tableHidden: true,
            authorized: true,
            maxValue: 0,
            minValue: Number.MAX_VALUE,
            channels: [],
            channelFilters: [true, true, true, true, true],
            filterValue: [],
            startDate: moment().subtract(7, 'days').toDate(),
            endDate: moment().toDate(),
            connectionsData: [],
            graphData: undefined,
            temperatureData: []
        };
        this.onExporting = this.onExporting.bind(this)
    }
    //get dataGrid(): dxDataGrid | undefined {
    //    return this.gridRef.current?.instance;
    //}

    

    componentDidMount(): void {


        //get alarms for logger here
        if (this.reloadData(this.state.startDate, this.state.endDate)) {
            this.setState({ tableHidden: false });
        }
        else {
            this.setState({ tableHidden: true });
        }

    }

    reloadData(start: Date, end: Date): boolean {
        let connectionsData = new Array<APIGetLoggerConnectionsModel>();
        const tempData: TemperatureData[] = []
        const graphData = new Array<
            {
                date: Date;
                signal: number | null;
                battery: number | null;
                temperature: number | null
            }
            >();
        this.setState({loading: true})
        //get alarms for logger here
        const me = this;

        if (me.props.serials != undefined) {

            const promises = new Array<Promise<any>>();
            // generate array of Promises each adding the connectionsData for a logger
            me.props.serials.forEach((serial: string) => {
                promises.push(
                    CallGetAPI(CreateUrl('/api/aquaguard/LoggerConnections?serial=' + serial + "&startDate=" + moment(start).format("yyyy-MM-DD") + "&endDate=" + moment(end).format("yyyy-MM-DD") + "T23:59:59"), {})
                        .then(json => {
                            connectionsData = connectionsData.concat(buildAPIGetLoggerConnectionsModel(json));
                        })
                        .catch(function (ex) {
                            me.setState(
                                {
                                    authorized: false,
                                    connectionsData: [],
                                    loading: false
                                });
                            console.log(ex);
                        })
                );
                promises.push(
                    CallGetAPI(CreateUrl(`/api/aquaguard/LoggerEvents?serial=${serial}&startDate=${moment(start).format("YYYY-MM-DD")}&endDate=${moment(end).format("YYYY-MM-DD")}`), {})
                        .then(response => {
                            console.log(response)
                            if (response && response.length > 0) {
                                response.forEach(d => {
                                    if (d.details) {
                                        const tempIdx = d.details.indexOf('Temp:')
                                        tempData.push({
                                            temperature: parseInt(d.details.slice(tempIdx + 6, tempIdx + 7)),
                                            date: new Date(d.dateCreated)
                                        })
                                    }
                                })
                                tempData.sort((a, b) => a.date.getTime() - b.date.getTime())
                            }
                            
                        })
                )
            });

            Promise.all(promises).then(() => {
                connectionsData.forEach((v: any) => {
                    let temperature = null
                    if (v.connectionTime != null) {
                        v.connectionTime = adjustTime(v.connectionTime);
                        console.log(moment(v.connectionTime))
                        tempData.forEach(temp => {
                            if (moment(v.connectionTime).isSame(temp.date, 'hour')) {
                                temperature = temp.temperature
                            }
                        })
                        
                        graphData.push({
                            date: new Date(v.connectionTime),
                            signal: v.latestRssi == 0 ? null : v.latestRssi,
                            battery: v.readBatteryChannel == 0 ? null : v.readBatteryChannel,
                            temperature: temperature
                        });
                    }
                });
                
                graphData.sort((a, b) => a.date.getTime() - b.date.getTime());
                console.log(graphData)
                me.setState({
                    connectionsData: connectionsData,
                    graphData: graphData,
                    loading: false
                });
            });
        }

        

        return true;
    }

    startDateChanged(e: any): void {
        const startDate = e.value

        this.setState({
            startDate: startDate
        });
       this.reloadData(startDate, this.state.endDate)
        
       
       
    }

    endDateChanged(e: any): void {
        const endDate = e.value
        this.setState({
            endDate: endDate
        });

        this.reloadData(this.state.startDate, endDate)
    }

    /// Customise Date/Time display
    dateColumnCustomizeText(cellInfo: any): string {
        if (cellInfo.value == null)
            return "";
        else
            return moment(adjustTime(cellInfo.value)).format("DD/MM/YYYY HH:mm:ss");
    }

    /// Customise ms duration into seconds
    columnCustomizeDuration(cellInfo: any): string {
        if (cellInfo.value == null)
            return "";
        else
            return (Math.round(cellInfo.value) / 1000).toFixed(3) + "s";
    }

    /// Customise connection result
    columnCustomizeResult(cellInfo: any, intl: IntlShape): string | undefined {

        const results = ["FAILED",
            "COMPLETED",
            "SEND_ERROR",
            "READ_ERROR",
            "READ_TIMEOUT",
            "CLIENT_DISCONNECTED",
            "PARSE_ERROR",
            "UNSUPPORTED_CLIENT",
            "LOG_DOWNLOAD_FAILED",
            "LOG_CRC_MISSMATCH",
            "SUCCESS",
            "FAILED_TO_AUTHENTICATE",
            "UNKNOWN_REQUEST",
            "DATABASE_ERROR",
            "UNIDENTIFIED",
            "INVALID"
        ];

        const intVal = parseInt(cellInfo.value);

        if (cellInfo.value == null
            || intVal == undefined
            || intVal < 0
            || intVal >= results.length) {
            return "";
        }
        else {
            return intl.formatMessage({ id: results[intVal] }); 
        }
    }

    onExporting(e: any): void {
        const me = this
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Connections');
        const downloadName = window.location.hostname.includes('zonelog.net') ? 'ZONELOG.NET Export' : 'Aquaguard Export'
        exportDataGrid({
            component: e.component,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: Buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${downloadName}-Connections from ${moment(me.state.startDate).format('DDMMMYYYY')} to ${moment(me.state.endDate).format('DDMMMYYYY')}.xlsx`);
                });
        });
        e.cancel = true;
    }


    render(): ReactNode {
        const {intl } = this.props
        return (

            <div>
                {this.state.loading &&
                    <div style={{
                        position: 'absolute', left: 'Calc(50% - 100px)', top: "50%",
                        transform: 'translate(-50%, -50%)',
                        zIndex: 13000

                    }}>
                        <Loader color={undefined} />
                    </div>
                }
                {!this.state.loading &&
                    <div>
                        {this.state.tableHidden &&
                                <ApiFailed />
                        }
                    {!this.state.tableHidden &&
                            <GridContainer>
                                {console.log(this.props.model) }
                            <GridItem xs={5} sm={5} md={5}>
                                    {intl.formatMessage({ id: "Start date" })} :&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={this.state.startDate} onValueChanged={this.startDateChanged.bind(this)} />
                            </GridItem>
                            <GridItem xs={5} sm={5} md={5}>
                                    {intl.formatMessage({ id: "End date" })} :&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={this.state.endDate} onValueChanged={this.endDateChanged.bind(this)} />
                            </GridItem>
                            <GridItem xs={2} sm={2} md={2}>
                                <div style={{ display: 'inline', float: "right" }}>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        onClick={(): boolean => this.reloadData(this.state.startDate, this.state.endDate)}
                                        aria-label="refresh"
                                    >
                                        <RefreshRoundedIcon />
                                    </IconButton>
                                </div>
                            </GridItem>
                           <GridItem xs={12} sm={12} md={12}>
                                <CustomTabs
                                    headerColor="info"
                                    tabs={[
                                        {
                                            tabName: intl.formatMessage({ id: "Data" }),
                                            tabIcon: TableChartOutlinedIcon,
                                            tabContent: (
                                                <DataGrid 
                                                    dataSource={this.state.connectionsData}
                                                    keyExpr="id"
                                                    ref={this.gridRef} 
                                                    defaultFilterValue={this.state.filterValue}
                                                    allowColumnResizing={true}
                                                    columnAutoWidth={true}
                                                    columnMinWidth={80}
                                                    onExporting={this.onExporting} >
                                                    <Scrolling mode="standard" useNative={true}/>
                                                    <FilterRow visible={true} />
                                                    <HeaderFilter visible={true} />
                                                    <Export enabled={true} />
                                                    <StateStoring enabled={true} type="localStorage" storageKey="connectionsPanelGrid" />
                                                    <Column dataField="id" visible={false} dataType="number" />
                                                    <Column dataField="loggerSerial" name="Logger" dataType="string" caption={intl.formatMessage({id: "Serial"}) } />
                                                    <Column dataField="clientEndPoint" name="From IP" dataType="string" caption={intl.formatMessage({ id: "Client End Point" })} />
                                                    <Column dataField="connectionTime" name="Connection" customizeText={this.dateColumnCustomizeText} dataType="datetime" width="120" defaultSortIndex={1} defaultSortOrder="desc" caption={intl.formatMessage({ id: "Connection Time" })} allowHeaderFiltering={false}/>
                                                    <Column dataField="alarmState" dataType="number" caption={intl.formatMessage({ id: "Alarm State" })} />
                                                    <Column dataField="rtcTime" name="Logger RTC" customizeText={this.dateColumnCustomizeText} dataType="datetime" width="120" caption={window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Package Time" }) : intl.formatMessage({ id: "RTC Time (UTC)" })} allowHeaderFiltering={false}/>
                                                    <Column dataField="latestRssi" name="RSSI" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Latest Signal" })} />
                                                    <Column dataField="readBatteryChannel" name="Battery" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Read Battery Channel" })} />
                                                    <Column dataField="logFirst" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Log First" })} />
                                                    <Column dataField="logLast" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Log Last" })} />
                                                    <Column dataField="logLastUpload" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Log Last Upload" })} />
                                                    <Column dataField="totalConnectionTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Total Connection Time" })} />
                                                    <Column dataField="logDownloadTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Log Download Time" })} />
                                                    <Column dataField="stdParamsDlTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Std Params Download Time" })} />
                                                    <Column dataField="calParamsDlTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Cal Params Download Time" })} />
                                                    <Column dataField="stdParamsUpdateTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Std Params Update Time" })} />
                                                    <Column dataField="firmwareUploadTime" customizeText={this.columnCustomizeDuration} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Firmware Upload Time" })} />
                                                    <Column dataField="firmwareUploadResult" customizeText={this.columnCustomizeResult} dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Firmware Upload Result" })} />
                                                    <Column dataField="logsDownloaded" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Logs Downloaded" })} />
                                                    <Column dataField="logsAvailable" dataType="number" allowHeaderFiltering={false} caption={intl.formatMessage({ id: "Logs Available" })} />
                                                    <Column dataField="connectionResult" customizeText={(cellInfo):React.ReactNode => this.columnCustomizeResult(cellInfo, this.props.intl)} dataType="number" caption={intl.formatMessage({ id: "Connection Result" })} />
                                                    <Pager allowedPageSizes={[10, 20, 50]} showPageSizeSelector={true} />
                                                    <Paging defaultPageSize={10} />
                                                </DataGrid>
                                            )
                                        },
                                        {
                                            tabName: intl.formatMessage({ id: "Graph" }),
                                            tabIcon: PollOutlinedIcon,
                                            tabContent: (
                                                <Chart dataSource={this.state.graphData}>
                                                
                                                    <CommonSeriesSettings
                                                        argumentField="date"
                                                        type="line"
                                                        ignoreEmptyPoints={true}>
                                                        <Aggregation
                                                            enabled={true}
                                                            method="avg"
                                                        />
                                                        <Point size={4} />
                                                    </CommonSeriesSettings>
                                                    <ValueAxis
                                                        name={intl.formatMessage({ id: "Signal" })}
                                                        visualRange={{ startValue: 0, endValue: 35 }}
                                                        allowDecimals={false}
                                                        position="left"
                                                        color="blue"
                                                        title={{ text: intl.formatMessage({ id: "Signal strength" }), font: { color: 'blue' }  }}
                                                    >
                                                        <Label font={{ color:'blue' }} />
                                                    </ValueAxis>
                                                    <ValueAxis
                                                        name={intl.formatMessage({ id: "Battery" })}
                                                        visualRange={{ startValue: 3, endValue: this.props.model === 'CHAR-E-FR' ? 8 :4 }}
                                                        allowDecimals={true}
                                                        position="right"
                                                        title={{ text: intl.formatMessage({ id: "Battery(V)" }), font: { color: 'green'} }}
                                                        color="green"
                                                    >
                                                        <Label font={{ color:'green' }} />
                                                    </ValueAxis>
                                                    <ValueAxis
                                                        name={intl.formatMessage({ id: "Temperature" })}
                                                        visualRange={{ startValue: -5, endValue: 40 }}
                                                        allowDecimals={true}
                                                        position="right"
                                                        title={{ text: intl.formatMessage({ id: "Temperature (C)" }), font: { color: 'red' } }}
                                                        color="red"
                                                    >
                                                        <Label font={{ color: 'red' }} />
                                                    </ValueAxis>
                                                    <ArgumentAxis
                                                        aggregationInterval={{ minutes: 1 }}
                                                        allowDecimals={false}
                                                        argumentType="datetime"
                                                        minValueMargin={0.1}
                                                        maxValueMargin={0.1}
                                                        color="black"
                                                        title={{ font: {color: 'black'} }}
                                                    />
                                                    <ZoomAndPan
                                                        argumentAxis="both"
                                                        valueAxis="none"
                                                    />
                                                    <ScrollBar
                                                        visible={true}
                                                    />
                                                    <Series valueField="signal" name={intl.formatMessage({ id: "Signal" })} color="blue" axis="Signal" />
                                                    <Series valueField="battery" name={intl.formatMessage({ id: "Battery" })} color="green" axis="Battery" />
                                                    <Series valueField="temperature" name={intl.formatMessage({ id: "Temperature (C)" })} color="red" axis="Temperature" />
                                                    <Legend visible={true} />
                                                </Chart>
                                            )
                                        }
                                    ]}
                                />
                            </GridItem>
                        </GridContainer>

                    }
                    </div>
                }

            </div>

        )
    }

}

export default injectIntl(withStyles(style)(ConnectionsPanel));